import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { DialogClass, DialogService } from '@services/dialog/';
import { FormsService } from '@services/forms';

import { IEquipmentTransfer, TransferStatus } from '@services/registrations/registrations.models';

import { BrsTokenService } from '@services/brs-token/';
import { AuthService } from '@src/app/services/auth';
import { RegistrationsService } from '@services/registrations';

import { SearchBikeComponent } from './components/search-bike/search-bike.component';
import { SearchUserComponent } from './components/search-user/search-user.component';

@Component({
	selector: 'app-registrations',
	templateUrl: './registrations.component.html',
	styleUrls: ['./registrations.component.scss']
})
export class RegistrationsComponent implements OnInit {
	public myRequests: IEquipmentTransfer[] = [];
	public allRequests: IEquipmentTransfer[] = [];
	public datedRequests: IEquipmentTransfer[] = [];

	public allowedTransfer = true;
	public selectedTab = 0;

	public searchForm = this.formBuilder.group({
		ctrFrom: [{ value: null, disabled: true }],
		ctrTo: [{ value: null, disabled: true }],
		ctrStatus: [''],
		ctrUser: ['']
	});

	public statuses = [
		{ id: TransferStatus.all, label: TransferStatus.all },
		{ id: TransferStatus.open, label: TransferStatus.open },
		{ id: TransferStatus.denied, label: TransferStatus.denied },
		{ id: TransferStatus.accepted, label: TransferStatus.accepted }
	];

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private authService: AuthService,
		private formBuilder: FormBuilder,
		private tokenService: BrsTokenService,
		private dialogService: DialogService,
		public registrationsService: RegistrationsService
	) { }

	public ngOnInit(): void {
		this.tokenService.getBrsToken().subscribe((brstoken: string) => {
			if (brstoken) {
				this.selectTab(this.selectedTab);
			}
		});
	}

	public selectTab(index: number) {
		this.selectedTab = index;

		switch (this.selectedTab) {
			case 0:
				this.registrationsService.getMyOpenTransfers().subscribe((res: IEquipmentTransfer[]) => {
					this.myRequests = res;
				});
				break;

			case 1:
				this.registrationsService.getAllOpenTransfers().subscribe((res: IEquipmentTransfer[]) => {
					this.allRequests = res;
				});
				break;

			case 2:
				this.initializeForm();
				break;
		}
	}

	public initializeForm() {
		this.searchForm.controls.ctrFrom.setValue(new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)); // 7 days back
		this.searchForm.controls.ctrTo.setValue(new Date()); // Today
		this.searchForm.controls.ctrStatus.setValue('any');
		this.searchForm.controls.ctrUser.setValue('');
	}

	public clearFilter(event: MouseEvent, filter?: string): void {
		switch (filter) {
			case 'ctrFrom':
				this.searchForm.controls.ctrFrom.setValue(null);
				break;

			case 'ctrTo':
				this.searchForm.controls.ctrTo.setValue(null);
				break;

			case 'ctrStatus':
				this.searchForm.controls.ctrStatus.setValue('');
				break;

			case 'ctrUser':
				this.searchForm.controls.ctrUser.setValue('');
				break;

			default:
				this.initializeForm();
				break;
		}

		event.preventDefault();
		event.stopPropagation();
	}

	public me(): void {
		this.searchForm.controls.ctrUser.setValue(this.authService.authUser['id']);
	}

	public submitRequestsHistory() {
		this.registrationsService.getAllTransfers(
			this.searchForm.controls.ctrFrom.value.toISOString().slice(0, 10),
			this.searchForm.controls.ctrTo.value.toISOString().slice(0, 10),
			this.searchForm.controls.ctrUser.value,
			this.searchForm.controls.ctrStatus.value
		).subscribe((res: IEquipmentTransfer[]) => {
			this.datedRequests = [];
			setTimeout(() => {
				this.datedRequests = res;
			});
		});
	}

	public createRequest(): void {
		this.dialogService.open(SearchBikeComponent, {
			panelClass: DialogClass.large,
			data: {
				request: { name: '' },
				callback: (requestId: string) => {
					if (requestId) {
						console.log('Request created with Id: ', requestId);
					}
				}
			}
		});
	}

	public searchUser(): void {
		this.dialogService.open(SearchUserComponent, {
			panelClass: DialogClass.large,
			data: {
				request: { name: '' },
				callback: (requestId: string) => {
					if (requestId) {
					}
				}
			}
		});
	}
}
